import AppStoreContext, { AppStore } from 'contexts/AppStoreContext';
import React from 'react';
import { downloadFileWithAnchor } from 'utils/general';

interface Props {
  filename: string;
  url: string;
  onDownloadStart?: () => void;
  onDownloadDone?: () => void;
}

interface State {
  downloading: boolean;
  downloadLabel: string;
  wasDownloaded: boolean;
}

class ExportTab extends React.Component<Props, State, AppStore> {
  constructor(props: Props, context: AppStore) {
    super(props, context);

    this.state = {
      downloading: false,
      downloadLabel: 'Ready to download',
      wasDownloaded: false,
    };
  }

  static contextType = AppStoreContext;

  context!: React.ContextType<typeof AppStoreContext>;

  handleDownloadClick = async (): Promise<void> => {
    console.log('Downloading...');
    const { filename, url, onDownloadDone, onDownloadStart } = this.props;

    if (onDownloadStart) {
      onDownloadStart();
    }

    this.setState({ downloading: true, downloadLabel: 'Downloading...' });
    await downloadFileWithAnchor(url, filename);
    this.setState({
      downloading: false,
      downloadLabel: 'Download Complete',
      wasDownloaded: true,
    });

    if (onDownloadDone) {
      onDownloadDone();
    }
  };

  render(): React.ReactNode {
    const { downloading, downloadLabel, wasDownloaded } = this.state;
    const { filename } = this.props;

    return (
      <div
        className="justify-between row align-center grow-1"
        style={{ borderBottom: 'solid 0.5px #dcdfe3' }}
      >
        <div>
          <div
            className="row justify-between center font-size-4 light black-1 my1"
            style={{
              paddingLeft: '16px',
              marginBottom: '8px',
              marginTop: '12px',
              width: 'auto',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {filename}
          </div>
          <div className="row align-start my2">
            <div
              className={
                downloading
                  ? 'mx3 bold color-primary-dark font-size-2 medium secondary-blue'
                  : 'mx3 font-size-2 normal black-2'
              }
            >
              {downloadLabel}
            </div>
          </div>
        </div>
        <div className="row items-center">
          <div
            className="font-size-4 normal mr2"
            onClick={this.handleDownloadClick}
          >
            {wasDownloaded ? 'Download Again' : 'Download'}
          </div>
        </div>
      </div>
    );
  }
}

export default ExportTab;
